import { useContext } from "react";
import { Popover } from "antd";
import { AppContext } from "../../context";

export function IsAssociateIcon({ iconSize, leftMargin }) {
  const info = useContext(AppContext);

  const hoverAHPContent = (
    <div style={{ padding: 10 }}>{info.t("isAssociate")}</div>
  );

  return (
    <div
      className="ahp-store-stamp"
      style={{
        // left: leftMargin,
        ...iconSize,
      }}
    >
      <Popover
        style={{
          width: 500,
        }}
        content={hoverAHPContent} // title="Hover title"
        trigger="hover" // visible={this.state.hovered}
        // onVisibleChange={this.handleHoverChange}
      >
        <img
          src="https://aldeias-oh.s3.eu-west-3.amazonaws.com/img/ahp-logo-black.png"
          alt="AHP logo"
          width={iconSize.width * 0.6}
        />
      </Popover>
    </div>
  );
}
